import { render, staticRenderFns } from "./VLogo.vue?vue&type=template&id=6e47ff20&scoped=true&"
var script = {}
import style0 from "./VLogo.vue?vue&type=style&index=0&id=6e47ff20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47ff20",
  null
  
)

export default component.exports